import Vue from 'vue'
import Dexie from 'dexie'

const database = new Dexie('Crm')

database.version(1).stores({
  'User': 'id',
  'UserSession': 'id',
  'Settings': 'id',
  'TableSettings': 'id'
})

export const bootstrap = async () => {
  await database.open()
  Vue.use({
    install (Vue) {
      Vue.prototype.$database = database
    }
  })
}

export default database
